var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _ellipse, _ellipse2, _path9, _ellipse3, _path0, _circle11, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg500Error = function Svg500Error(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 250,
    fill: "none",
    viewBox: "0 0 256 250"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M193.67 88H77.33C68.863 88 62 89.123 62 90.507v26.986c0 1.384 6.863 2.507 15.33 2.507h116.34c8.467 0 15.33-1.123 15.33-2.507V90.507c0-1.384-6.863-2.507-15.33-2.507"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M193.67 57H77.33C68.863 57 62 58.123 62 59.507v26.986C62 87.877 68.863 89 77.33 89h116.34c8.467 0 15.33-1.123 15.33-2.507V59.507c0-1.384-6.863-2.507-15.33-2.507"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M202.393 88h-66.394v32h66.394c4.201 0 7.606-1.123 7.606-2.507V90.507c0-1.384-3.405-2.507-7.606-2.507"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M202.393 57h-66.394v32h66.394c4.201 0 7.606-1.123 7.606-2.507V59.507c0-1.384-3.405-2.507-7.606-2.507"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M193.67 118H77.33c-8.467 0-15.33 1.123-15.33 2.507v26.986c0 1.384 6.863 2.507 15.33 2.507h116.34c8.467 0 15.33-1.123 15.33-2.507v-26.986c0-1.384-6.863-2.507-15.33-2.507"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M193.67 148H77.33c-8.467 0-15.33 1.123-15.33 2.507v26.986c0 1.384 6.863 2.507 15.33 2.507h116.34c8.467 0 15.33-1.123 15.33-2.507v-26.986c0-1.384-6.863-2.507-15.33-2.507"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M202.313 118H136v32h66.313c4.245 0 7.687-1.123 7.687-2.507v-26.986c0-1.384-3.442-2.507-7.687-2.507"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M202.312 148h-66.313l.001 32h66.312c4.246 0 7.687-1.123 7.687-2.507v-26.986c0-1.384-3.441-2.507-7.687-2.507"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.072,
    cy: 105.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.072,
    cy: 73.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.072,
    cy: 135.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.072,
    cy: 164.984,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.287,
    cy: 105.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.287,
    cy: 73.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.287,
    cy: 135.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.287,
    cy: 164.984,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.504,
    cy: 105.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.504,
    cy: 73.072,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.504,
    cy: 135.24,
    r: 3.072,
    fill: "#ADBCFF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.504,
    cy: 164.984,
    r: 3.072,
    fill: "#ADBCFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.5,
    cy: 120,
    fill: "#19216F",
    rx: 66.5,
    ry: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.5,
    cy: 89,
    fill: "#19216F",
    rx: 66.5,
    ry: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M207 120c0 1.105-31.788 2-71 2v-4c39.212 0 71 .895 71 2M205 89c0 1.105-30.892 2-69 2v-4c38.108 0 69 .895 69 2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.5,
    cy: 150,
    fill: "#19216F",
    rx: 66.5,
    ry: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3992",
    d: "M207 150c0 1.105-31.788 2-71 2v-4c39.212 0 71 .895 71 2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.932,
    cy: 166.369,
    r: 3.482,
    fill: "#ADBCFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M66.248 204.335c21.676 0 39.247-17.312 39.247-38.668S87.924 127 66.248 127 27 144.312 27 165.667c0 21.356 17.572 38.668 39.248 38.668"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M67.752 127h-.123v77.335h.123c21.678 0 39.247-17.31 39.247-38.668 0-21.357-17.57-38.667-39.247-38.667"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#19216F",
    d: "M71.588 140.373h-8.195v36.779h8.195zM67.492 192.373c2.49 0 4.508-1.988 4.508-4.441s-2.019-4.441-4.508-4.441c-2.49 0-4.508 1.989-4.508 4.441s2.018 4.441 4.508 4.441"
  })));
};
export { Svg500Error as Icon };
export default __webpack_public_path__ + "static/media/6be39c8eb8c7c3098b3b6c3b28749375.svg";